var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "chart-box-top" }, [
        _c("span", { staticClass: "chart-title" }, [
          _vm._v("公司一般事件趋势图")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "chart-select-container" }, [
          _c(
            "div",
            { staticClass: "el-select-wrapper" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.onDimensionChange },
                  model: {
                    value: _vm.dimension,
                    callback: function($$v) {
                      _vm.dimension = $$v
                    },
                    expression: "dimension"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { value: "month", label: "月份时间维度" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { value: "dept", label: "责任部门维度" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "el-select-wrapper" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.symptom,
                    callback: function($$v) {
                      _vm.symptom = $$v
                    },
                    expression: "symptom"
                  }
                },
                _vm._l(_vm.symptomOptions, function(item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: { label: item.name, value: item.code }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { ref: "chart", staticClass: "chart-main" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "明细列表",
            visible: _vm.detailVisible,
            width: "95%"
          },
          on: {
            "update:visible": function($event) {
              _vm.detailVisible = $event
            }
          }
        },
        [
          _vm.detailVisible
            ? _c("SeriousErrorDetail", {
                ref: "detail",
                attrs: {
                  "kpi-code": _vm.symptom,
                  company: _vm.company,
                  year: _vm.year,
                  month: _vm.barMonth,
                  "initial-dept-id": _vm.barDeptId,
                  "dept-ids": _vm.barDeptIds
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fcc2ad6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fcc2ad6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/result/SeriousError.vue
// module id = null
// module chunks = 